import { useFormContext } from 'react-hook-form'

import { Switch } from 'components/Form'
import { useDataForAdUnitBidderSwitch } from 'features/globalSetup'
import { AdUnitBidderSlice } from 'features/inventory/ad-unit/forms/PrebidStackForm'
import { Schema } from 'features/inventory/ad-unit/forms/PrebidStackForm/schema'
import { useAbility } from 'providers/casl'
import { isDisabledByYieldbirdDenied, isDisabledByYieldbirdRequested } from '../../utils'

type Props = Pick<
  AdUnitBidderSlice,
  'accountType' | 'csRequiredParams' | 'id' | 'workspaceBidderStatus'
>

export const CsEnabledCell = ({
  accountType,
  csRequiredParams,
  id,
  workspaceBidderStatus,
}: Props): React.JSX.Element => {
  const ability = useAbility()
  const { control } = useFormContext<Schema>()

  const { isDisabled, tooltip } = useDataForAdUnitBidderSwitch({
    isDisabledByAuth:
      ability.cannot('update', 'AdUnit') || ability.cannot('update', 'GlobalSetupFeature-bidder'),
    isDisabledByRequiredParams: !csRequiredParams,
    isDisabledByYieldbirdDenied: isDisabledByYieldbirdDenied(accountType, workspaceBidderStatus),
    isDisabledByYieldbirdRequested: isDisabledByYieldbirdRequested(
      accountType,
      workspaceBidderStatus,
    ),
    paramsKind: 'cs',
  })

  return (
    <Switch<Schema>
      control={control}
      disabled={isDisabled}
      name={`adUnitBiddersAttributes.${id}.csEnabled`}
      tooltip={tooltip}
      tooltipMode='wrap'
    />
  )
}
